export class NotificacoesSuporteWhatsapp {
  private processando = false;

  constructor(private api: any, private whatsapp: any, private obtenhaUsuario: () => any) {}

  async processe(): Promise<void> {
    if (this.processando || !this.whatsapp.podeEnviarNotificacaoAutomatica()) return;

    this.processando = true;
    try {
      await this.processeTicket();
      if (this.whatsapp.podeEnviarNotificacaoAutomatica()) await this.processeCobranca();
    } finally {
      this.processando = false;
    }
  }

  private async envie(item: any, id: string): Promise<any> {
    const msg: any = {
      id, telefone: item.grupoDestinoChatId || '', mensagem: item.mensagem,
      tipo: 'SISTEMA', tipoDeNotificacao: item.tipoDeNotificacao || 'Mensagem do Sistema',
      naoRegistrarServidor: true, assinar: false, fazerPreview: false
    };
    // WAPI prioriza o nome do grupo se ambos forem fornecidos.
    if (!item.grupoDestinoChatId) msg.nomeGrupoDestino = item.grupoDestinoNome;

    try {
      const resultado = await this.whatsapp.envieNotificacaoSemAssinatura(msg, this.obtenhaUsuario);
      const sucesso = resultado?.sucesso === true && resultado.status === 'ENVIADA';
      return {sucesso, erro: sucesso ? null : (resultado?.mensagem || resultado?.status || 'Envio não confirmado'),
        ...(resultado?.incerto ? {incerto: true} : {})};
    } catch (erro) {
      return {sucesso: false, erro: erro?.message || String(erro), ...(erro?.incerto ? {incerto: true} : {})};
    }
  }

  private async processeTicket(): Promise<void> {
    try {
      const item = await this.api.reserveNotificacaoWhatsapp();
      if (!item?.id || !item.token) return;
      const resultado = await this.envie(item, 'suporte-sistema-' + item.id);
      await this.api.concluaNotificacaoWhatsapp(item.id, {token: item.token, ...resultado});
    } catch (erro) {
      console.error('[Suporte] Erro ao processar notificação de ticket:', erro);
    }
  }

  private async processeCobranca(): Promise<void> {
    try {
      let item = await this.api.reserveNotificacaoCobrancaWhatsapp();
      if (!item?.id || !item.token) return;
      const id = item.id;
      const token = item.token;

      while (item?.id === id && item.token === token && item.ordem) {
        const resultado = await this.envie(item, 'fatura-cobranca-' + id + '-' + item.ordem + '-' + (item.versaoRevisao || 0));
        item = await this.api.concluaNotificacaoCobrancaWhatsapp(id, {
          token, ordem: item.ordem, ...resultado
        });
        if (!resultado.sucesso) break;
      }
    } catch (erro) {
      // Não converta perda da resposta de conclusão em falha de entrega:
      // o servidor pode já ter avançado a ordem com sucesso.
      console.error('[Suporte] Erro ao processar notificação de cobrança:', erro);
    }
  }
}
